// extracted by mini-css-extract-plugin
export default {"root":"style_root__7Mnw6","icon":"style_icon__gMV-n","label":"style_label__b+KyR"};